<template>
  <w-dialog closeFree width="564px" :title="dialog.title" top="calc(50vh - 200px)" v-model="dialog.visible" class="pop-dialog pop-import" @ok="onConfirm">
    <!-- {{ form }} -->
    <el-form :model="form" :rules="rules" ref="form" label-width="0" class="import-con">
      <div class="tips">{{ dialog.info }}</div>
      <el-form-item label="" prop="file">
        <el-upload ref="tops" class="upload-con" :accept="dialog.accept" drag action="#" :multiple="false" :limit="1" :before-upload="beforeUpload" :on-exceed="onExceed" :on-remove="onRemove" :http-request="httpRequest">

          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            点击上传附件，或拖拽文件到此处
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
  </w-dialog>
</template>

<script>
export default {
  name: "popImport",
  components: {},
  data() {
    return {
      dialog: {
        title: '',
        info: '',
        accept: '.xls,.xlsx',
        maxSzie: '4',
        visible: false,
      },
      loading: false,
      form: {
        file: '',
      },
      rules: {
        file: [
          { required: true, message: '请选择文件', trigger: 'blur' },
        ],
      },
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    close() {
      this.dialog.visible = false
    },
    show(data) {
      this.dialog = {
        ...data,
        visible: true
      }
      this.form.file = ''
      // this.$nextTick(() => {
      //   this.$refs['form'].clearFiles()
      // })
    },
    beforeUpload(file) {
      console.log('beforeUpload',file)
      const maxMb = Number(this.dialog.maxSize) || 0
      const size = file.size || 0
      const isMaxSize = size / 1024 / 1024 < maxMb;
      console.log('>>', size, isMaxSize, maxMb)
      if (!isMaxSize) {
        this.$message.error('文件大小不能超过' + this.dialog.maxSize + 'MB')
        return false
      }
      this.form.file = file.file
      this.$refs['form'].clearValidate()
      return true
    },
    httpRequest(file) {
      this.form.file = file.file
    },
    onExceed() {
      this.$message.error('只能上传1个文件')
    },
    onRemove() {
      this.form.file = ''
    },
    onConfirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log('>>', this.form.file)
          const formData = new FormData()
          this.loading = true
          formData.append('file', this.form.file)
          this.$emit('onImport', formData)
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      // this.$api.omsImport(formData).then((res) => {
      //     if (res.code == 0) {
      //         this.$message.success('操作成功')
      //         this.visibleDialog = false
      //         this.$emit('fetchData')
      //     }
      // }).finally(() => {
      //     this.loading = false
      // })
    },
  }
}
</script>

<style lang="scss" scoped>
.pop-dialog /deep/ {
  .el-dialog__header {
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }

  .el-dialog__body {
    padding: 10px 32px 20px 32px;
  }

  .el-form-item {
    margin-bottom: 26px;
  }

  .is-error .el-upload-dragger {
    border-color: #F56C6C;
  }

  .upload-con {
    line-height: 0;
  }

  .upload-con .el-upload-dragger {
    width: 500px;
    height: 160px;
    border-radius: 4px;

    .el-icon-upload {
      margin: 36px 0 8px;
      font-size: 40px;
      color: #B3BACB;
    }

    .el-upload__text {
      font-size: 12px;
    }
  }

  .el-dialog__footer {
    padding: 6px 0 26px;
  }
}

.pop-import {
  .tips {
    font-size: 12px;
    color: #7F7F7F;
    height: 27px;
    line-height: 17px;
  }

  .el-upload-list__item {
    font-size: 12px;
    line-height: 25px;

    .el-icon-close {
      font-size: 16px;
    }
  }
}
</style>
